/**
 * Ponte fra le camere del sito e il motore di prenotazione Krossbooking.
 *
 * `detailrt` e' l'identificativo con cui il motore riconosce la camera: e' lo
 * stesso numero che Krossbooking usa come id_room_type, verificato camera per
 * camera. Serve per portare l'ospite direttamente sulla camera che ha scelto.
 */

const MOTORE = "https://newmoonrooms.kross.travel/book/step1";

// Il motore accetta solo alcune lingue: per le altre lo lasciamo decidere a lui.
const LINGUE_MOTORE = ["it", "en", "de", "fr", "es"];

export const CAMERE_KROSS = {
  // Cavour, Corso Cavour 160
  glamour: { detailrt: 1, struttura: "cavour", maxOspiti: 4 },
  tiffany: { detailrt: 11, struttura: "cavour", maxOspiti: 4 },
  cassia: { detailrt: 10, struttura: "cavour", maxOspiti: 4 },
  white: { detailrt: 8, struttura: "cavour", maxOspiti: 2 },
  rose: { detailrt: 6, struttura: "cavour", maxOspiti: 2 },
  green: { detailrt: 5, struttura: "cavour", maxOspiti: 2 },
  grey: { detailrt: 7, struttura: "cavour", maxOspiti: 2 },
  blue: { detailrt: 4, struttura: "cavour", maxOspiti: 2 },

  // Del Prione, Via del Prione 165
  one: { detailrt: 12, struttura: "prione", maxOspiti: 2 },
  two: { detailrt: 13, struttura: "prione", maxOspiti: 2 },
  three: { detailrt: 14, struttura: "prione", maxOspiti: 2 },
  four: { detailrt: 15, struttura: "prione", maxOspiti: 2 },
};

function conLingua(url, lingua) {
  if (lingua && LINGUE_MOTORE.includes(lingua)) {
    url.searchParams.set("kross_lang", lingua);
  }
  return url.toString();
}

/**
 * Link per una camera sola: l'ospite atterra su quella camera, con le sue date.
 * Senza date il motore scrive "non disponibile per il periodo selezionato",
 * quindi le date sono obbligatorie.
 */
export function linkCamera({ slug, dal, al, ospiti = 2, lingua }) {
  const camera = CAMERE_KROSS[slug];
  if (!camera || !dal || !al) return null;

  const url = new URL(MOTORE);
  url.searchParams.set("from", dal);
  url.searchParams.set("to", al);
  url.searchParams.set("detailrt", String(camera.detailrt));
  url.searchParams.set("guests", String(ospiti));

  return conLingua(url, lingua);
}

/**
 * Link per piu' camere insieme: il motore prepara uno spazio per ognuna, con
 * il numero giusto di ospiti dentro. Le camere precise le sceglie l'ospite:
 * `detailrt` accetta un solo valore, quindi con piu' camere resta a zero.
 *
 * `ospitiPerCamera` e' un elenco tipo [4, 2, 2].
 */
export function linkCombinazione({ ospitiPerCamera, dal, al, lingua }) {
  if (!Array.isArray(ospitiPerCamera) || !ospitiPerCamera.length) return null;
  if (!dal || !al) return null;

  // Formato atteso dal motore: "4,0;2,0;" cioe' adulti,bambini per camera.
  const composizione = ospitiPerCamera.map((n) => `${n},0`).join(";") + ";";

  const url = new URL(MOTORE);
  url.searchParams.set("from", dal);
  url.searchParams.set("to", al);
  url.searchParams.set("guests_rooms", composizione);
  url.searchParams.set("detailrt", "0");

  return conLingua(url, lingua);
}
